

export interface IClassTemplate {
    id: number,
    name: string,
    description: string,

    studyCycle: string,
    studyLevel: string,
    level: number,
    studySection: string,
    studyLanguage: string,
    
    timeSlotCategory: string,

    studyTrack: string,
    previousStudyTrack: string,
    isFinalClass: boolean
  }


  export const defaultClassTemplate : IClassTemplate = {
    id: 0,
    name: '',    
    description: '',

    studyCycle: '',
    studyLevel: '',
    level: 1,
    studySection: '',
    studyLanguage: '',
    
    timeSlotCategory: '',

    studyTrack: '',
    previousStudyTrack: '',
    isFinalClass: false
  }

  export interface IClassTemplateSearch {
    studyLevel: string,
    studyLanguage: string,

    name: string,
    description: string
  }